import React from 'react';
import { imageGlobalUrl } from '../../../utils/api'
export default class EvaluteItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderStar(number) {
    let arr = [];

    for (let index = 0; index < number; index++) {
      const element = (
        <img
          key={index}
          src={require('../../../assets/images/icon_star.png')}
        />
      );

      arr.push(element);
    }

    return arr;
  }

  render() {
    const _this = this;

    return (
      <div>
        {_this.props.evaluateList.map((item, index) => {
          return (
            <div className="inner-evaluate" key={item.id}>
              <div className="evaluate-item">
                <div className="item-user">
                  <div className="user-avatar">
                    <img src={imageGlobalUrl + item.avatar} />
                  </div>

                  <div className="user-stars">
                    <p className="username">{item.userName}</p>

                    <p className="stars">{_this.renderStar(item.stars)}</p>
                  </div>
                </div>

                <div className="item-content">
                  <p>{item.content}</p>
                </div>
              </div>

              {_this.props.evaluateList.length == index + 1 ? null : (
                <div className="separator-line"></div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}
